export const ALGOLIA_PRODUCTS_INDEX_NAME = 'wp_product_index';
export const ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_NAME = 'wp_product_index_query_suggestions';
export const ALGOLIA_ARTICLES_INDEX_NAME = 'wp_blog_post_index';
// export const ALGOLIA_FAQ_INDEX_NAME = 'autocomplete_demo_faq';
export const ALGOLIA_PAGE_INDICES = [
  'wp_page_index',
  'wp_post_index',
  // Add any other page indices you have
];